"use client";
import React, { Suspense } from "react";
import BuySell from "./buySell";
import Link from "next/link";
import { motion } from "framer-motion";
import { fadeIn, textVariant } from "../../utils/motion";
import { setShowProfileForm } from "../../redux/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import OtpModal from "../modals/otpModal";
import SetProfileForNewUser from "../setProfile";
import Image from "next/image";

const HeroSection = () => {
  const dispatch = useDispatch();
  const otpModal = useSelector((state: RootState) => state.auth.otpModal);
  const showProfileForm = useSelector((state: RootState) => state.auth.showProfileForm);
  const onClose = () => dispatch(setShowProfileForm(false));

  const line =
    "We at Bright DiGi Gold invite you to embark on a journey of effortless digital savings. In just a few clicks make your savings grow in Digital Gold and Silver. Your gateway to hassle-free savings is here.";

  return (
    <div className="bg-theme mt-24 sm:mt-32 sm:mb-4">
      {otpModal && <OtpModal />}
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
        className="mx-auto px-4 sm:px-6 lg:px-16"
      >
        <div className="relative">
          <Image
            src="https://brightdigigold.s3.ap-south-1.amazonaws.com/bdgwhite5.webp"
            alt="Bright DiGi Gold background"
            width={620}
            height={270}
            className="hidden sm:block absolute top-[206px] left-[176px] opacity-30"
            loading="lazy"
          />
        </div>

        <div className="grid lg:grid-cols-2 gap-4">
          <div className="hidden lg:block mt-10">
            <motion.h1
              variants={fadeIn("right", "spring", 0.2, 0.2)}
              className="text-white mb-12"
              style={{ fontSize: "4rem", lineHeight: "2.5rem" }}
            >
              <span className="text-themeBlueLight extrabold">
                Start Your Savings
              </span>
              <br />
              <span className="font-thin flex items-center bold leading-tight">
                With Just
                <span className="mt-2 ml-2">
                  <Image
                    src="/Rupees.png"
                    alt="rupees icon"
                    width={45}
                    height={45}
                    priority={true}
                    loading="eager"
                  />
                </span>
                10 <span className="text-gold01">.</span>
              </span>
            </motion.h1>
            <motion.div variants={textVariant(1.1)}>
              <div className="inline-flex items-center border-gold rounded-lg px-2 py-1">
                <Image
                  width={40}
                  height={40}
                  src="/Goldbarbanner.png"
                  alt="Digital Gold Bar"
                  priority
                />
                <p className="text-gold01 p-1 px-3 ml-3 lg:text-lg xl:text-xl poppins-semibold">
                  Best Platform to Buy & Sell 24K Digital Gold
                </p>
              </div>
              <motion.p
                className="text-white leading-8 text-lg text-justify mb-4 mt-6 pr-0 sm:pr-28 poppins-regular"
                variants={textVariant(1.2)}
              >
                {line}
              </motion.p>
              <div className="flex items-center">
                <p className="text-xl font-bold text-white">Trusted By</p>
                <Image
                  width={180}
                  height={140}
                  className="ml-2 mt-2"
                  src="/Startup_India.svg"
                  alt="Startup India logo"
                  priority
                />
              </div>
              <div className="flex gap-5 mt-8">
                <Link
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.brightdigigold.customer"
                >
                  <Image
                    src="https://brightdigigold.s3.ap-south-1.amazonaws.com/google-play-button.png"
                    alt="Google Play Store button"
                    width={256}
                    height={79}
                    priority
                  />
                </Link>
                <Link
                  target="_blank"
                  href="https://apps.apple.com/in/app/bright-digi-gold-buy-24k-gold/id1640972173"
                >
                  <Image
                    src="https://brightdigigold.s3.ap-south-1.amazonaws.com/app-store-button+(2).png"
                    alt="App Store button"
                    width={256}
                    height={79}
                    priority
                  />
                </Link>
              </div>
            </motion.div>
          </div>
          <motion.div variants={fadeIn("bottom", "spring", 0.5, 0.5)}>
            <Suspense>
              <BuySell />
            </Suspense>
          </motion.div>
        </div>
        {showProfileForm && (
          <SetProfileForNewUser isOpen={showProfileForm} onClose={onClose} />
        )}
      </motion.div>
    </div>
  );
};

export default HeroSection;